import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CloseIconBlue from "../img/svg/close_blue_new_design.svg";
import { useSelector } from "react-redux";
import { isPartnerMaoflaamit } from "../store/partnerStore";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(0),
  },
  "& .MuiDialog-paper": {
    borderRadius: "var(--dialog-border-radius)",
  },
}));

export default function DeleteClientCreditCardPopup({
  isOpen,
  setIsOpen,
  headerText,
  bodyText,
  deleteText,
  cancelText,
  handleDelete,
  handleCancel,
}) {
  const isMaoflaamit = useSelector(isPartnerMaoflaamit);
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{
        p: 0,
        // maxWidth: "320px"
      }}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <Box>
        <Box>
          <DialogTitle
            sx={{
              m: 0,
              px: 3,
              pt: 3,
              textAlign: "end",
              color: "var(--red-text-color)",
              fontWeight: 700,
              fontSize: "24px",
              fontFamily: `var(--font-family) !important`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline",
            }}
            id="customized-dialog-title"
          >
            <img src={CloseIconBlue} alt="close" onClick={handleClose} />
            <p
              style={{
                lineHeight: "24px",
                direction: "rtl",
                textAlign: "right",
              }}
            >
              {headerText}
            </p>
          </DialogTitle>
        </Box>
        <DialogContent
          sx={{
            direction: "rtl",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            gutterBottom
            sx={{
              lineHeight: "24px",
              fontSize: "16px",
              fontFamily: `var(--font-family) !important`,
              textAlign: "right",
              mb: "40px",
              color: "#565656",
            }}
          >
            {bodyText}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 0 }}>
          <Button
            variant="contained"
            onClick={() => handleCancel()}
            className={`phone-dialog-btn w-100-percents ${isMaoflaamit ? "phone-dialog-red-btn" : "phone-dialog-secondary-btn"}`}
            sx={{
              height: "58px",
              fontFamily: `var(--font-family) !important`,
              fontWeight: 700,
            }}
          >
            {cancelText}
          </Button>
          <Button
            variant="contained"
            className={`phone-dialog-btn w-100-percents ${isMaoflaamit ? "phone-dialog-secondary-btn" : "phone-dialog-red-btn"}`}
            onClick={() => handleDelete()}
            sx={{
              height: "58px",
              fontFamily: `var(--font-family) !important`,
              fontWeight: 700,
            }}
          >
            {deleteText}
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
}
